<!--
 * @Author: Alfred huqitaoit@gmail.com
 * @Date: 2021-12-20 11:08:35
 * @LastEditors: Alfred
 * @LastEditTime: 2023-12-15 14:44:11
 * @Description:
 * @FilePath: \src\views\order\OrderRefundAudit.vue
-->
<template>
  <div class="order-refund-audit">
    <div class="tuolele-main-box">
      <div class="tuolele-main-search">
        <el-form :inline="true" :model="search">
          <el-form-item label="状态">
            <el-select v-model="search.status">
              <el-option label="全部" value="" />
              <el-option
                v-for="(value,key) in statusLists"
                :key="key"
                :label="value"
                :value="key"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <TgbAuditDetail
      :search.sync="search"
    />
  </div>
</template>
<script>
import TgbAuditDetail from '@/components/order/TgbAuditDetail.vue'
export default {
  name: 'OrderRefundAudit',
  components: {
    TgbAuditDetail
  },
  data() {
    return {
      type: 'refundAudit',
      search: {
        status: ''
      },
      statusLists: {
        '1': '已上传待审核',
        '2': '已完成',
        '3': '已拒绝',
        '5': '已关闭'
      }
    }
  },
  mounted() {},
  methods: {

  }
}
</script>
<style lang="scss"></style>
